import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

// modules

// components
import { HidePipe } from '@app/_pipes/hide.pipe';
import { SubmitFormDirective } from '@app/_directives/submit-form.directive';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { ErrorSummaryComponent } from './components/error-summary/error-summary.component';
import { FullScreenLoaderComponent } from './components/full-screen-loader/full-screen-loader.component';
import { PageErrorStateComponent } from './components/page-error-state/page-error-state.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        HidePipe,
        SubmitFormDirective,
        ErrorMessageComponent,
        ErrorSummaryComponent,
        FullScreenLoaderComponent,
        PageErrorStateComponent,
    ],
    exports: [
        CommonModule,
        TranslateModule,
        HidePipe,
        SubmitFormDirective,
        ErrorMessageComponent,
        ErrorSummaryComponent,
        FullScreenLoaderComponent,
        PageErrorStateComponent
    ]
})
export class SharedModule { }
